// Change-request types whose approved value is applied automatically by the backend
export const CR_AUTO_APPLY_TYPES = ["Salary Revision", "Leave Adjustment", "Shift Change"];

